/* eslint-disable no-unused-vars */
import { getLocalStorageApi, STORAGE_KEYS } from 'utilities/localStorage';

const defaultOrgLocalStorage = getLocalStorageApi(STORAGE_KEYS.DEFAULT_ORG, {
  id: "7b6ca193-5144-4835-a292-be30f744492b"
});

const selectedOrg = localStorage.getItem('selectedOrganizationId');

const blankUser = {
  id: '',
  name: '',
  email: '',
  phone: '',
  address: {
    line1: '',
    line2: '',
    city: '',
    state: '',
    zipCode: '',
    country: '',
    addressId: ''
  },
  applicatorLicenseNumber: '',
  applicatorLicenseExpirationDateEpoch: '',
  applicatorLicenseExpirationDate: '',
  notes: ''
};

export default blankUser;
